import { AppointmentStatus } from '@dataTypes/appointment.type'

export const NAV_ITEMS = [
  {
    label: 'Day',
    value: 'day',
  },
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Month',
    value: 'month',
  },
]

export const APPT_STATUS_MENU_ITEMS = {
  [AppointmentStatus.Confirmed]: {
    text: 'Confirm',
    id: 'status-confirm',
    position: 0,
  },
  [AppointmentStatus.Unconfirmed]: {
    text: 'Unconfirmed',
    id: 'status-unconfirmed',
    position: 1,
  },
  [AppointmentStatus.Late]: { text: 'Late', id: 'status-late', position: 2 },
  [AppointmentStatus.NoShow]: {
    text: 'No-show',
    id: 'status-noshow',
    position: 3,
  },
  [AppointmentStatus.CheckIn]: {
    text: 'Check-in',
    id: 'status-checkin',
    position: 4,
  },
  [AppointmentStatus.InTreatment]: {
    text: 'In-treatment',
    id: 'status-intreatment',
    position: 5,
  },
  [AppointmentStatus.CheckOut]: {
    text: 'Check-out',
    id: 'status-checkout',
    position: 6,
  },
  [AppointmentStatus.Completed]: {
    text: 'Complete',
    id: 'status-complete',
    position: 7,
  },
}
